import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@bd/bdui-modal';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import CoreMap from '@bd/bdui-coremap';
import HomeMapPopupCard from './HomeMapPopupCard';
import { typography } from '../styles';

const modalStyles = css`
  position: absolute;
  z-index: 1;
  top: 80px;
  left: 20px;
  width: calc(100vw - 40px);
  @media (min-width: 992px) {
    max-width: 900px;
    left: 50%;
    transform: translateX(-50%);
  }
  .HomeMapModal_closeButton {
    position: absolute;
    z-index: 1;
    top: -60px;
    right: 0;
    width: 40px;
    height: 40px;
    background-color: transparent;
    background-image: none;
    padding: 0;
    border: none;
    cursor: pointer;
    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 36px;
      height: 2px;
      background-color: white;
      border-radius: 1px;
    }
    &::before {
      transform: translateX(-50%) translateY(-50%) rotateZ(-45deg);
    }
    &::after {
      transform: translateX(-50%) translateY(-50%) rotateZ(45deg);
    }
  }
`;

const mapStyles = css`
  width: 100%;
  height: calc(100vh - 100px);
  max-height: 700px;
  .leaflet-container {
    font-family: ${typography.SansSerif};
    a.leaflet-popup-close-button {
      display: block;
      color: #eee;
      width: 20px;
      height: 20px;
      &:focus {
        outline-width: 2px !important;
        outline-style: solid !important;
        outline-color: Highlight !important;
        @media (-webkit-min-device-pixel-ratio: 0) {
          outline-color: -webkit-focus-ring-color !important;
          outline-style: auto !important;
        }
      }
    }
  }
  .leaflet-popup-content-wrapper {
    border-radius: 0;
    padding: 0;
  }
  .leaflet-popup-content {
    margin: 0;
    width: 230px !important;
  }
`;

const modalOverlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background-color: rgba(0,0,0, 0.85);
  overflow-y: auto;
`;


class HomeMapModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
  }

  openModal(e) {
    let currentElem = e.target;

    while (currentElem.tagName !== 'A' && currentElem.parentNode !== document) {
      currentElem = currentElem.parentNode;
    }

    if (currentElem.nodeName !== 'A') {
      e.preventDefault();
      this.setState({
        modalIsOpen: true,
      }, () => {
        setTimeout(() => {
          this.setState({
            activePin: this.props.homeId,
          });
        });
      });
      document.body.style.overflow = 'hidden';
    }
  }

  closeModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      modalIsOpen: false,
      activePin: undefined,
    });
    document.body.style.overflow = '';
  }

  render() {
    const { activePin } = this.state;
    const { children, className, homes } = this.props;

    return (
      <div className={className}>
        <button className="HomeMapModal_openButton" type="button" onClick={this.openModal}>
          {children}
        </button>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Contact Modal"
          className={modalStyles}
          overlayClassName={modalOverlayStyles}
        >
          <button
            className="HomeMapModal_closeButton"
            type="button"
            onClick={this.closeModal}
            aria-label="Close map modal"
          />
          <CoreMap
            animate
            pin={{
              iconUrl: '/images/i-map-pin-alt.svg',
              iconSize: [25.5, 34.5],
              iconAnchor: [12.75, 34.5],
              popupAnchor: [0, -39.5],
            }}
            activePin={activePin}
            className={mapStyles}
            markers={homes}
            popup={({ marker: home }) => (
              <HomeMapPopupCard home={home} />
            )}
          />
        </Modal>
      </div>
    );
  }
}

HomeMapModal.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  homeId: PropTypes.string.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

HomeMapModal.defaultProps = {
  className: undefined,
};

export default withData({
  homes: true,
})(HomeMapModal);



// WEBPACK FOOTER //
// ./src/components/HomeMapModal.js